import styled from 'styled-components';
import { Colors, Link, Text } from '@origin-digital/style-guide';
import React from 'react';
import { Box } from '@origin-digital/ods-core';

interface CaptchaDisclaimerProps {
  noPadding?: boolean;
}

interface CaptchaTextProps {
  children: React.ReactChild;
}

const CaptchaText: React.FC<CaptchaTextProps> = ({ children }) => (
  <Text inline color="grey48" size="xs">
    {children}
  </Text>
);

const CaptchaDisclaimer: React.FC<CaptchaDisclaimerProps> = ({ noPadding }) => (
  <Box paddingTop={noPadding ? 'none' : 'large'}>
    <DisclaimerText data-id="captcha-disclaimer">
      <CaptchaText>This site is protected by reCAPTCHA and the Google </CaptchaText>
      <Link
        href="https://policies.google.com/privacy"
        target="_blank"
        data-id="captcha-privacy-link"
      >
        <CaptchaText>Privacy Policy</CaptchaText>
      </Link>
      <CaptchaText> and </CaptchaText>
      <Link href="https://policies.google.com/terms" target="_blank" data-id="captcha-terms-link">
        <CaptchaText>Terms of Service</CaptchaText>
      </Link>
      <CaptchaText> apply</CaptchaText>
    </DisclaimerText>
  </Box>
);

const DisclaimerText = styled.div`
  a:link,
  a:visited,
  a:hover,
  a:active {
    color: ${Colors.GREY48};
  }
`;

export { CaptchaDisclaimer };
